import { gql } from '@apollo/client';

export const SEND_FBO_FUEL_STATEMENT = gql`
  mutation SendFboFuelStatement(
    $ids: [ID!]!
    $statementDate: ISO8601Date!
  ) {
    sendFboFuelStatement(
      ids: $ids
      statementDate: $statementDate
    ) {
      errors {
        message
        path
      }
    }
  }
`
